import {
    GET_SERVICE_INTERVAL, UPDATE_SERVICE_INTERVAL, SERVICE_INTERVAL_ERROR, RESET_SERVICE_INTERVAL
} from '../actions/types';


const initialState = { service_intervals: [], service_interval: null, loading: true, error: {} }

export default function (state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case GET_SERVICE_INTERVAL:
            return {
                ...state,
                service_interval: payload,
                loading: false
            }
        case UPDATE_SERVICE_INTERVAL:
            return {
                ...state,
                service_interval: [...state.service_interval, payload],
                loading: false
            }
        case SERVICE_INTERVAL_ERROR:
            return {
                ...state,
                error: payload,
                loading: false
            }
        case RESET_SERVICE_INTERVAL:
            return {
                ...state,
                service_interval: null,
                loading: false
            }
        default:
            return state;
    }

}